import { useState } from 'react';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Checkbox } from '@/common/components/Checkbox/Checkbox';
import { DateField } from '@/common/components/Fields/DateField/DateField';
import { DigitsField } from '@/common/components/Fields/DigitsField/DigitsField';
import { MoneyField } from '@/common/components/Fields/MoneyField/MoneyField';
import { PasswordField } from '@/common/components/Fields/PasswordField/PasswordField';
import {
  PhoneField,
  TPhoneFieldValue,
} from '@/common/components/Fields/PhoneField/PhoneField';
import { SelectField } from '@/common/components/Fields/SelectField/SelectField';
import { TextField } from '@/common/components/Fields/TextField/TextField';
import { Label } from '@/common/components/Label/Label';
import { RadioButton } from '@/common/components/RadioButton/RadioButton';
import { Stack } from '@/common/components/Stack/Stack';
import { TMoney } from '@coverflex-tech/hypernova-utils';
import { type Option } from '@rn-primitives/select';

export const PlaygroundForms = () => {
  const [textFieldValue, setTextFieldValue] = useState('');
  const [passwordFieldValue, setPasswordFieldValue] = useState('');
  const [amountFieldValue, setAmountFieldValue] = useState<TMoney | null>();
  const [dateFieldValue, setDateFieldValue] = useState<Date | null>(null);
  const [selectFieldValue, setSelectFieldValue] = useState<Option>();
  const [radioValue, setRadioValue] = useState<string>();
  const [checkboxValue, setCheckboxValue] = useState(false);
  const [digitsFieldValue, setDigitsFieldValue] = useState<string>('');
  const [phoneFieldValue, setPhoneFieldValue] =
    useState<TPhoneFieldValue | null>(null);

  return (
    <Stack gap="md">
      <TextField
        id="floating-text-field"
        label="Floating Text Field"
        value={textFieldValue}
        onChange={(evt) => {
          setTextFieldValue(evt.nativeEvent.text);
        }}
      />
      <PasswordField
        id="floating-password-field"
        label="Floating Password Field"
        value={passwordFieldValue}
        onChange={(evt) => {
          setPasswordFieldValue(evt.nativeEvent.text);
        }}
      />
      <MoneyField
        id="floating-money-field"
        label="Floating Money Field"
        amount={amountFieldValue}
        onChange={(amount) => {
          setAmountFieldValue(amount);
        }}
        availableLabel="Available"
        availableAmount={{ amount: 100, currency: 'EUR' }}
      />
      <MoneyField
        id="floating-money-field-inline"
        label="Floating Money Field Inline"
        inline
        amount={amountFieldValue}
        onChange={(amount) => {
          setAmountFieldValue(amount);
        }}
        availableLabel="Available"
        availableAmount={{ amount: 100, currency: 'EUR' }}
        currencySymbol="€"
      />
      <DateField
        id="floating-date-field"
        label="Floating Date Field"
        value={dateFieldValue}
        onChange={(date) => {
          setDateFieldValue(date);
        }}
      />
      <SelectField
        value={selectFieldValue}
        id="select"
        label="Answer"
        onChange={(val) => {
          setSelectFieldValue(val);
        }}
        options={[
          {
            label: 'Answer 1',
            value: 'answer-1',
          },
          {
            label: 'Answer 2',
            value: 'answer-2',
          },
        ]}
      />
      <PhoneField
        ids={{
          codeField: 'code-field',
          numberField: 'number-field',
        }}
        value={phoneFieldValue}
        onChange={(value) => {
          setPhoneFieldValue(value);
        }}
        language="fr"
        labels={{
          codeField: 'Code',
          numberField: 'Number',
        }}
        suggestedCountries={['PT', 'ES', 'IT']}
      />
      <RadioButton.Group
        title="Radio Button"
        description="Using React Native Primitives"
        variant="card"
        gap="2xs"
        value={radioValue}
        onChange={setRadioValue}
        hint="This is a hint message"
        error={radioValue === 'two' ? 'This is an error message' : undefined}
      >
        <RadioButton.Option
          label="Label One"
          description="Description One"
          value="one"
          rightContent={
            <Stack gap="xs" align="end">
              <Label bold>8.888,88 /m</Label>
              <BodyText size="sm" color="neutral20">
                avg 88,88€ /employee
              </BodyText>
            </Stack>
          }
        />
        <RadioButton.Option
          label="Label Two"
          description="Description Two"
          value="two"
          rightContent={
            <Stack gap="xs" align="end">
              <Label bold>8.888,88 /m</Label>
              <BodyText size="sm" color="neutral20">
                avg 88,88€ /employee
              </BodyText>
            </Stack>
          }
        />
      </RadioButton.Group>
      <Checkbox
        label="Checkbox"
        description="Description"
        checked={checkboxValue}
        onChange={() => {
          setCheckboxValue(!checkboxValue);
        }}
      />
      <Checkbox
        label="Checkbox Card"
        description="Description Card"
        variant="card"
        checked={checkboxValue}
        onChange={() => {
          setCheckboxValue(!checkboxValue);
        }}
      />
      <DigitsField
        id="digits-field"
        value={digitsFieldValue}
        onChange={(digits) => {
          setDigitsFieldValue(digits);
        }}
      />
    </Stack>
  );
};
